import { TerminalSettingsService } from "./terminal-settings.service";
import {
    EventListDto,
    TerminalSettingDto,
    TerminalSettingsListDto,
} from "@shared/service-proxies/service-proxies";
import {
    CreateOrEditTerminalSettingDto,
    EventsServiceProxy,
} from "./../../../../shared/service-proxies/service-proxies";
import {
    Component,
    EventEmitter,
    Injector,
    OnInit,
    Output,
    ViewChild,
} from "@angular/core";
import { AppComponentBase } from "@shared/common/app-component-base";
import { AppSessionService } from "@shared/common/session/app-session.service";
import { TerminalSettingsServiceProxy } from "../../../../shared/service-proxies/service-proxies";
import { ModalDirective } from "ngx-bootstrap";

@Component({
    selector: "terminalSettingsModal",
    templateUrl: "./terminal-settings-modal.component.html",
    styleUrls: ["./terminal-settings-modal.component.css"],
})
export class TerminalSettingsModalComponent
    extends AppComponentBase
    implements OnInit
{
    @ViewChild("terminalSettingsModal") modal: ModalDirective;
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    public active = false;
    public saving = false;

    terminal: TerminalSettingsListDto;

    terminals = [];
    listEvents = [];
    events = [];

    public settings: CreateOrEditTerminalSettingDto;

    constructor(
        injector: Injector,
        private _terminalSettingsService: TerminalSettingsServiceProxy,
        private _settingsService: TerminalSettingsService,
        private _eventsService: EventsServiceProxy,
        private _appSessionService: AppSessionService
    ) {
        super(injector);
    }

    ngOnInit() {
        this.terminal = this._settingsService.getSettings();
        this.active = true;
    }

    ngAfterViewChecked(): void {
        //Temporary fix for: https://github.com/valor-software/ngx-bootstrap/issues/1508
        $("tabset ul.nav").addClass("m-tabs-line");
        $("tabset ul.nav li a.nav-link").addClass("m-tabs__link");
    }

    show(): void {
        this.initializeModal();
    }

    initializeModal(): void {
        this.modal.show();
        this.terminal = this._settingsService.getSettings();
        this.active = true;
        if (this.terminal) this.getSettings();
    }

    getSettings() {
        if (this.terminal && this.terminal.id > 0) {
            this._terminalSettingsService
                .getTerminalSettingForEdit(this.terminal.id)
                .subscribe((result) => {
                    if (result && result.terminalSetting.id) {
                        this.settings = result.terminalSetting;
                        this.listEvents = this.settings.eventsList.map(
                            (x) => x as EventListDto
                        );
                    }
                });
        } else {
            this.settings = new CreateOrEditTerminalSettingDto();
            this.settings.isActive = true;
            this.settings.showRelatedEvents = true;
            this.settings.allowCurrentAnnuity = true;
            this.settings.allowCredential = true;
            this.settings.allowRegistration = true;
            this.settings.sessionTimeoutSeconds = 60;
            this.settings.sessionNoticeTimeoutSeconds = 30;
            this.settings.numberOfCredentialsCopy = 2;
            this.settings.showCredentialBarcode = true;
            this.settings.fontSizeName = 16;
            this.settings.fontSizeCity = 12;
        }
    }

    onModalShown() {}

    // Get Events
    filterEvents(event): void {
        this._eventsService
            .getEventsForSelect(
                event.query,
                0,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                true,
                undefined,
                10,
                0
            )
            .subscribe((result) => {
                this.events = result.items;
            });
    }

    filterTerminals(event): void {
        this._terminalSettingsService
            .getTerminalSettingsForSelect(event.query, null, 10, 0)
            .subscribe((result) => {
                this.terminals = result.items;
            });
    }

    onSelectTerminal() {
        this.getSettings();
    }

    createNew() {
        this.terminal = undefined;
        this.listEvents = [];
        this.settings = new CreateOrEditTerminalSettingDto();
        this.settings.isActive = true;
        this.settings.showRelatedEvents = true;
        this.settings.allowCurrentAnnuity = true;
        this.settings.allowRegistration = true;
        this.settings.allowCredential = true;
    }

    onSelectEvent() {}

    save(): void {
        if (
            !this.settings.allowCredential &&
            !this.settings.allowCurrentAnnuity &&
            !this.settings.allowRegistration
        ) {
            this.message.info(
                "Permita ao menos um modo de acesso. Inscrição, Anuidade ou Credencial",
                "Modo de acesso não definido"
            );
            return;
        }

        this.settings.eventsList = this.listEvents.map(
            (x) => x as EventListDto
        );

        if (!this.settings.mainEventName) {
            this.settings.mainEventName =
                this.listEvents.length > 0
                    ? this.settings.eventsList[0].name
                    : "";
        }

        this.saving = true;
        this._terminalSettingsService
            .createOrEdit(this.settings)
            .finally(() => {
                this.saving = false;
            })
            .subscribe((id) => {
                this.settings.id = id;
                this._settingsService.setSettings(this.settings);

                this.close();
                this.modalSave.emit(null);
                setTimeout(function () {
                    location.reload();
                }, 1000);
            });
    }

    updateSessionTimeout(isPlus: boolean) {
        if (isPlus) this.settings.sessionTimeoutSeconds++;
        else {
            this.settings.sessionTimeoutSeconds--;
            if (this.settings.sessionTimeoutSeconds <= 0)
                this.settings.sessionTimeoutSeconds = 1;
        }
    }

    updateNoticeTimeout(isPlus: boolean) {
        if (isPlus) this.settings.sessionNoticeTimeoutSeconds++;
        else {
            this.settings.sessionNoticeTimeoutSeconds--;
            if (this.settings.sessionNoticeTimeoutSeconds <= 0)
                this.settings.sessionNoticeTimeoutSeconds = 1;
        }
    }

    updateFontSizeName(isPlus: boolean) {
        if (isPlus) this.settings.fontSizeName++;
        else {
            this.settings.fontSizeName--;
            if (this.settings.fontSizeName <= 0) this.settings.fontSizeName = 1;
        }
    }

    updateFontSizeCity(isPlus: boolean) {
        if (isPlus) this.settings.fontSizeCity++;
        else {
            this.settings.fontSizeCity--;
            if (this.settings.fontSizeCity <= 0) this.settings.fontSizeCity = 1;
        }
    }

    close(): void {
        this.active = false;

        this.saving = false;

        this.terminal = undefined;
        this.settings = undefined;
        this.terminals = [];
        this.listEvents = [];
        this.events = [];
        this.modal.hide();
    }
}



// WEBPACK FOOTER //
// ./src/congress/shared/layout/terminal/terminal-settings-modal.component.ts